<template>
  <van-popup
    v-model="showNewMsgModal"
    get-container="body"
    position="center"
    round
    closeable
    :style="{ width: '92vw', maxWidth: '720px' }"
    @close="closePopup()"
  >
    <div style="padding: 18px 18px 12px">
      <div style="font-size: 26px; font-weight: 700; padding-right: 34px">
        {{ newMsgModalData.name }}
      </div>
      <div
        style="
          margin-top: 12px;
          font-size: 18px;
          line-height: 1.5;
          max-height: 60vh;
          overflow: auto;
          white-space: pre-wrap;
        "
      >
        {{ newMsgModalData.text }}
      </div>
      <div style="margin-top: 14px">
        <van-button
          type="primary"
          block
          style="
            border: none;
            background: linear-gradient(180deg, #fc78af, #f22678);
            font-size: 24px;
            height: 46px;
            border-radius: 10px;
          "
          @click="$emit('update:showNewMsgModal', false)"
          >OK</van-button
        >
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    showNewMsgModal: {
      type: Boolean,
      default: false,
    },
    newMsgModalData: {
      type: Object,
      default: () => ({ name: "", text: "" }),
    },
  },
  data() {
    return {};
  },
  methods: {
    closePopup() {
      this.readMsg(this.newMsgModalData.id);
      this.$emit("update:showNewMsgModal", false);
    },
    readMsg(key) {
      this.$http({
        method: "get",
        url: "read_msg",
        data: { id: key },
      });
    },
  },
};
</script>